import { render } from "./UEWasteListView.vue?vue&type=template&id=2d1732a6&scoped=true"
import script from "./UEWasteListView.vue?vue&type=script&lang=js"
export * from "./UEWasteListView.vue?vue&type=script&lang=js"

import "./UEWasteListView.vue?vue&type=style&index=0&id=2d1732a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1732a6"]])

export default __exports__